<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right" v-if="this.pid">
    <div style="margin-bottom:1px">
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
      <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
        <el-descriptions-item  label="房产信息">
          <el-input style="width: 100%;" placeholder="请输入内容" v-model="house"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <Space direction="vertical" size="large">
            <RadioGroup v-model="state">
                <Radio label="1">待审核</Radio>
                <Radio label="2">已审核</Radio>
                <Radio label="">全部</Radio>
            </RadioGroup>
          </Space>
        </el-descriptions-item>
        <el-descriptions-item  label="收费项目">
          <el-select style="width: 100%;" size="mini" v-model="chargeitemID" multiple filterable collapse-tags placeholder="收费项目" class="kuan">
            <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item  label="计费周期">
          <el-date-picker v-model="startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
          <span style="margin-left: 1px;margin-right: 1px;">至</span>
          <el-date-picker v-model="endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item  label="导出">
          <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="excelPost">导出账单</el-button>
        </el-descriptions-item>
        <el-descriptions-item  label="导入">
          <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="modals">导入账单</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div style="margin-top: 5px;"></div>
    <div style="color: red;" v-if="loading">加载中...</div>
    <div style="color: #156df1;" v-else>加载完成</div>
    <el-table ref="multipleTable" :data="data" border tooltip-effect="dark" style="width: 100%" height="500">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="pindex_name" label="项目" width="200"></el-table-column>
      <el-table-column prop="stutes" label="状态" width="180"></el-table-column>
      <el-table-column prop="user" label="导入人" width="80"></el-table-column>
      <el-table-column prop="check_user" label="审核人" width="80"></el-table-column>
      <el-table-column prop="user_date" label="导入时间" width="180"></el-table-column>
      <el-table-column prop="check_user_date" label="审核时间" width="180"></el-table-column>
      <el-table-column prop="remarks" label="备注" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <div style="display: flex;">
            <div style="cursor:pointer;" v-if="ERP.isPermission(4003003001) && scope.row.stutes=='待审核'">
              <div @click="states(scope.row.id)" style="color: red;">审核</div>
            </div>
            <div style="cursor:pointer;margin-left: 5px;">
              <div @click="download(scope.row.url)" style="color: #156df1">下载</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="data">
      <Page :total="count" :page-size="pageSize" @on-change="change"  show-total />
    </div>
  </div>
    <!-- 导入 -->
    <Modal
      v-model="modal"
      ok-text="确定"
      width="600"
      :loading="loadingModal"
      title="导入欠费账单修改"
      @on-ok="add">
      <div>
         <el-form style="height: 600px;overflow: auto;">
           <div>
             <span><span class="cdj_span">*</span>选择项目</span>
             <div class="cdj_input">
               <el-select v-model="form.pindex_id" filterable placeholder="请选项目" class="cdj_el_select">
                 <el-option
                   v-for="item in options"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </div>
           </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>上传文件</span>
            <el-upload
                style="color: #ffffff;"
                class="upload-demo cdj_input"
                :action="url"
                :before-remove="beforeRemove"
                :on-success="handleAvatarSuccess"
                accept=".xls,.xlsx"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload">
                <el-button size="small" type="primary" class="texts">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls或xlsx文件，不能大于15m</div>
            </el-upload>
          </div>
         </el-form>
      </div>
   </Modal>
    <!-- 审核 -->
    <Modal
       v-model="statesModal"
       ok-text="确定"
       width="600"
       title="审核"
       :loading="loadingModal"
       @on-ok="statesAdd">
       <div>
          <el-form style="height: 600px;overflow: auto;">
            <div>
                <div>
                  <span><span class="cdj_span">*</span>审核</span>
                  <div class="cdj_input">
                    <el-select v-model="statesForm.stutes" filterable placeholder="请选项目" class="cdj_el_select">
                      <el-option
                        key="2"
                        label="通过"
                        value="2">
                      </el-option>
                        <el-option
                        key="3"
                        label="拒绝"
                        value="3">
                      </el-option>
                    </el-select>
                  </div>
              </div>
              <div class="cdj_margin_span">
                <span>备注</span>
                <el-input class="cdj_input" type="textarea" :rows="6" placeholder="请输入内容" v-model="statesForm.remarks"></el-input>
              </div>
           </div>
          </el-form>
       </div>
    </Modal>
</div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js"
import ErpProject from "../Common/erp-project";
export default {
  name: "DiscountExcel",
  components: {ErpProject},
  data () {
    return {
      date:{
        startDate:'',
        endDate:''
      },
      startDate:'',
      endDate:'',
      house:'',
      modal:false,
      statesModal:false,
      loading:false,
      loadingModal:true,
      chargeitem:[],
      options: [],
      count:0,
      pageSize:12,
      data: '',
      pid: '',
      text:'',
      chargeitemID:'',
      state:'',
      url:'',
      fileList:[],
      form:{
        pindex_id:'',
        name:'',
        url:'',
      },
      statesForm:{
        id:'',
        stutes:'',
        remarks:''
      }
    }
  },
  components: {
    "erp-tree": () => import('../Common/erp-tree.vue'),
  },
  created() {
  },
  mounted(){
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.url = this.$myhttp.defaults.baseURL + "/admin/excel?"+"login_name="+login+"&token="+token;
    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.options = backdata.data.data;
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });
    this.change(1);
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  methods: {
    nodeClick(e){
      this.pid=e.tree[0].pindex_id;
      this.house=e.tree.map(ret=>{return ret.name}).join('->');
      this.change(1)
    },
    modals(){
      this.form.pindex_id = this.pid;
      this.modal = true;
    },
    //导入
    add(){
      if(this.form.pindex_id == ''){
        this.$Message.error('项目不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.form.url == ''){
        this.$Message.error('上传文件不能为空!');
        this.loadingModals();
        return false;
      }
      this.$myhttp.post('admin/OrderDiscountExcel/add',this.form,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            this.form = {
              pindex_id:'',
              name:'',
              url:'',
            };
            this.fileList = [];
            this.change(1);
            this.modal = false;
            this.$Message.success('提交成功!');
          }
      });
    },
    //审核
    states(id){
      this.statesForm.id = id;
      this.statesModal = true;
    },
    statesAdd(){
      if(this.statesForm.id == ""){
        this.$Message.error('id不能为空');
        this.loadingModals();
        return false;
      }
      if(this.statesForm.stutes == ""){
        this.$Message.error('审核状态不能为空');
        this.loadingModals();
        return false;
      }
      this.$myhttp.post('admin/OrderDiscountExcel/statesAdd',this.statesForm,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            this.statesForm = {
              id:'',
              stutes:'',
              remarks:'',
            };
            this.change(1);
            this.statesModal = false;
            // this.$Message.success('操作成功，已提交系统处理');
            this.confirm(backdata.data.message);//提示
          }else{
            this.change(1);
            this.confirm(backdata.data.message);//提示
            //this.$Message.error(backdata.data.message);
            this.loadingModals();
          }
      }).catch(() => {
        this.loadingModals();
        this.confirm(backdata.data.message);//提示
        //this.$Message.error(backdata.data.message);
      });
    },
    confirm(message){
      this.$confirm(''+message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      })
    },
    //分页
    change(page){
      this.loading = true;
      this.$myhttp.get('admin/OrderDiscountExcel/index?page='+page+ '&state='+ this.state+"&chargeitemID="+this.chargeitemID+'&text='+this.text+'&pid='+this.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          if(backdata.data.code == 200){
            let data = backdata.data.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
          }
          this.loading = false;
      });
    },
    //搜索
    searchs(){
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    //时间转换
    dates() {
      if (this.startDate != null && this.startDate != "") {
        let d = this.startDate; //开始时间
        let startDate = new Date(d).getTime() / 1000;
        startDate = Number(startDate).toFixed(0);
        this.date.startDate = startDate;
      }
      if (this.endDate != null && this.endDate != "") {
        let d = this.endDate; //开始时间
        let endDate = new Date(d).getTime() / 1000;
        endDate = Number(endDate).toFixed(0);
        this.date.endDate = endDate;
      }
    },
    //导出
    excelPost(){
      if(this.pid == ''){
        this.$Message.error('点击左边树选择项目');
        return false;
      }
      if(this.house == ''){
        this.$Message.error('房产信息不能为空');
        return false;
      }
      if(this.chargeitemID == ''){
        this.$Message.error('费用类型不能为空');
        return false;
      }
      this.dates();
      this.loading = true;
      this.$myhttp.get('admin/OrderDiscountExcel/excel?state='+this.state+"&chargeitemID="+this.chargeitemID+'&pid='+this.pid+'&house='+this.house+'&startDate='+this.date.startDate+'&endDate='+this.date.endDate,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.loading = false;
          let data = backdata.data;
          if(data.code == 201){
            this.$Message.error(data.message);
          }
          if(data.code == 200){
            var login = window.localStorage.getItem('login');
            var token = window.localStorage.getItem('token');
            let url = imgurl+data.data+'?'+"&login_name="+login+"&token="+token;
            window.open(url, '_blank');
            this.$Message.success(data.message);
          }
      });
    },
    //上传
    //超过一个文件
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      this.$message.warning(`一次只允许上传1个文件`);
    },
    //删除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //限制大小
    beforeAvatarUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 15;
      if (!isLt7M) {
        this.$message.error('上传文件大小不能超过 8MB!');
      }
      return isLt7M;
    },
    //上传成功返回
    handleAvatarSuccess(res, file){
      this.form.url = file.response[0];
    },
    //下载
    download(url){
      var login = window.localStorage.getItem('login');
      var token = window.localStorage.getItem('token');
      // window.location.href = imgurl+'/'+url+'?'+"&login_name="+login+"&token="+token;
      let urls = imgurl+'/'+url+'?'+"&login_name="+login+"&token="+token;
      window.open(urls, '_blank');
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    }
  },
  watch:{

  },
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}
.d-flex {
    display: flex;
  }

  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
  }

  .demo-spin-icon-load{
      animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
      from { transform: rotate(0deg);}
      50%  { transform: rotate(180deg);}
      to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
      height: 100px;
      position: relative;
  }
  .loading{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90%;
    width: 85%;
  }
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/discountExcel.vue